var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartIconBordered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.218,
    height: 22.355,
    viewBox: "0 0 24.218 22.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-heart-empty",
    "data-name": "Icon ionic-md-heart-empty",
    d: "M20.933,4.5a7.163,7.163,0,0,0-5.449,2.556A7.163,7.163,0,0,0,10.035,4.5a6.584,6.584,0,0,0-6.66,6.7c0,4.628,4.116,8.342,10.351,14.071l1.758,1.583,1.758-1.583c6.235-5.729,10.351-9.443,10.351-14.071A6.584,6.584,0,0,0,20.933,4.5Zm-4.7,19.171-.245.227-.5.454-.5-.454-.245-.227a74,74,0,0,1-7.143-7.1c-1.63-2.02-2.352-3.673-2.352-5.368a4.842,4.842,0,0,1,1.38-3.452,4.738,4.738,0,0,1,3.412-1.386,5.339,5.339,0,0,1,4.023,1.892l1.426,1.694L16.91,8.255a5.32,5.32,0,0,1,4.023-1.892A4.761,4.761,0,0,1,24.35,7.748,4.852,4.852,0,0,1,25.73,11.2c0,1.688-.728,3.347-2.352,5.368A74.147,74.147,0,0,1,16.229,23.671Z",
    transform: "translate(-3.375 -4.5)",
    fill: "#222327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconBordered);
export default __webpack_public_path__ + "static/media/heart-icon-bordered.fefb4bc049185244b4d0567caac9ed98.svg";
export { ForwardRef as ReactComponent };